<div class="signature-page">

  <div class="pad-container">
    <canvas #canvas
            (touchstart)="startDrawing($event)"
            (touchmove)="moved($event)"
            class="signature-canvas"></canvas>
  </div>

  <div class="actions">
    <dx-button text="Pulisci" stylingMode="outlined" (onClick)="clearPad()"></dx-button>
    <!-- <dx-button text="Salva firma" type="success" (onClick)="savePad()"></dx-button> -->
  </div>

</div>
